var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style['text-message']] = !_vm.hasButtons, _obj[_vm.$style['text-message-with-buttons']] = _vm.hasButtons, _obj )},[_c('div',{class:_vm.$style['content']},[_vm._v(" "+_vm._s(_vm.content.value)+" ")]),_vm._t("buttonsContainer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }